// extracted by mini-css-extract-plugin
export default {"onHoldWarning":"OnHoldWarning_onHoldWarning__iuO3c"};